import _nearestColorObj from "nearest-color";
const nearestColorObj = _nearestColorObj;
const colors = {
  "black": "#000000",
  "red": "#ff0000",
  "green": "#00ff00",
  "yellow": "#ffff00",
  "blue": "#0000ff",
  "magenta": "#ff00ff",
  "cyan": "#00ffff",
  "white": "#ffffff"
};
/* Takes plaintext with no formatting */
export default (function getNearestColor(color) {
  if (color === "cyan") {
    color = "#00ffff";
  }
  if (color === "magenta") {
    color = "#ff00ff";
  }
  if (color === "transparent") {
    return "#000000";
  }
  let nearestColor = nearestColorObj.from(colors);
  //remove & from color
  color = color.replace(/&/g, '');
  // #RRGGBBAA → #RRGGBB (nearest-color ignores alpha; palette is opaque)
  color = color.replace(/^#([0-9a-fA-F]{6})[0-9a-fA-F]{2}$/i, '#$1');
  // #RGBA → #RRGGBB (expand RGB digits, drop alpha)
  color = color.replace(/^#([0-9a-fA-F])([0-9a-fA-F])([0-9a-fA-F])[0-9a-fA-F]$/i, (_, r, g, b) => `#${r}${r}${g}${g}${b}${b}`);
  return nearestColor(color);
});